import * as DesktopActions from './actions';
import * as DesktopAppConstants from './constants';
import * as D from './deps';
import DesktopAppReducers from './reducer';
import DesktopAppWatchers from './sagas/watchers';
import * as DesktopAppSelectors from './selectors';
import * as DesktopAppUtils from './utils';

export default D.createDomainModule({
  name: 'desktopApp',
  components: {},
  utils: DesktopAppUtils,
  actions: DesktopActions,
  constants: DesktopAppConstants,
  selectors: DesktopAppSelectors,
  reducer: DesktopAppReducers,
  onStart() {
    this.registeredHandlers = D.registerHandlers(DesktopAppWatchers);
  },
  persisted: true,
});
